<template>
  <div class="search-detaile table-def-pg">
    <div class="search-pg">
      <Search />
    </div>
    <div class="breadcrumb-wrap">
      <div class="container">
        <v-breadcrumbs :items="breadcrumbs" />
      </div>
    </div>
    <div class="container">
      <div class="position">
        <div class="bg-white p-20">
          <div class="search-body">
            <div class="search-result">
              <div>
                <div class="search-result-body">
                  <div class="type-column">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>
                              {{ $t('Наименование') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody v-show="showArchive === false" v-if="successorDevelopers.length > 0">
                          <tr
                            v-for="developer in successorDevelopers"
                            :key="developer.developer.id"
                          >
                            <td>
                              <DeveloperTreeNode :node="developer" />
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-show="showArchive === true" v-if="developers.length > 0">
                        <tr
                          v-for="developer in developers"
                          :key="developer.developer.id"
                        >
                          <td>
                            <DeveloperTreeNode :node="developer" />
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </div>
                <div class="search-result-footer">
                  <p>{{ $t('Общее количество') }}: {{ showArchive === true ? developersTotal : successorDevelopersTotal }}</p>
                  <p>
                    <a
                      href="#"
                      v-show="showArchive === true"
                      :aria-label="$t('Показать разработчиков')"
                      @click.prevent="showArchive = false"
                      v-if="successorDevelopers.length > 0"
                    >
                      {{ $t('Разработчики') }}
                    </a>
                    <a
                      href="#"
                      v-show="showArchive === false"
                      :aria-label="$t('Показать архив разработчиков')"
                      @click.prevent="showArchive = true"
                      v-if="developers.length > 0"
                    >
                      {{ $t('Архив разработчиков') }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CMS from '@/model/cms'
import { mapMutations } from 'vuex'
import Search from '@/components/Search'
import DeveloperTreeNode from '@/components/widget/DeveloperTreeNode'
import {Trans} from "@/plugins/Translation"

export default {
  components: {
    Search,
    DeveloperTreeNode
  },
  data: () => ({
    developers: [],
    successorDevelopers: [],
    breadcrumbs: [],
    developersTotal: 0,
    successorDevelopersTotal: 0,
    showArchive: false
  }),
  watch: {
    '$route.query'(qs) {
      this.fetchData(qs)
    }
  },
  metaInfo () {
    return {
      title: this.$i18n.t('NPADevelopersTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('NPADevelopersDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('NPADevelopersKeywordsSEO'),
      }]
    }
  },
  created() {
    this.fetchData(this.$route.query)
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData(qs) {
      this.setLoading(true)
      CMS.getNpaDeveloper()
        .then((response) => {
          this.developers = response.data.items
          this.successorDevelopers = response.data.successorItems
          this.developersTotal = response.data.itemsCount
          this.successorDevelopersTotal = response.data.successorItemsCount

          this.breadcrumbs = [
            { text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/' }
          ]

          if (response.data.parentMenu) {
            const breadcrumb = {}
            breadcrumb.text = response.data.parentMenu.transName
            breadcrumb.disabled = true
            this.breadcrumbs.push(breadcrumb)
          }

          this.setLoading(false)
        })
        .catch((error) => {
          //console.log(error)
          this.setLoading(false)
        })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
